<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Realizar pagos de Cliente
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta corriente</span>
      <span> /</span>
      <span>Realizar pagos de Cliente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<app-pagos-cliente-cabecera (onRealizarPago)="onRealizarPago($event)"
  (onfechaPagoCheque)="onfechaPagoCheque($event)"></app-pagos-cliente-cabecera>

<app-pagos-cliente-docs-ctas (onConformeAbono)="onConformeAbono($event)"
  (onObtenerSaldoDocumentoError)="onObtenerSaldoDocumentoError()"></app-pagos-cliente-docs-ctas>

<app-pagos-cliente-formas-pago (onSaldo)="MontoxSaldo($event)"></app-pagos-cliente-formas-pago>

<app-pagos-cliente-formas-pago-tabs [bloqueado]="bloquearIngresoMediosPago"
  (onFormaPagoAgregada)="onFormaPagoAgregada($event)">
</app-pagos-cliente-formas-pago-tabs>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-0 justify-content-between align-items-center">
    <h6 class="pl-2">Cliente con pagos realizados:
      <strong *ngIf="registrosGuardados?.pagos">{{registrosGuardados.pagos.length | numerico}}</strong>
      <strong *ngIf="!registrosGuardados?.pagos">0</strong>
    </h6>
    <div>
      <button size="sm" mdbBtn type="button" color="default" (click)="cancelar()" mdbWavesEffect class="btn btn-sm">
        Cancelar
      </button>
      <button *ngIf="!enableGuardarYPasar" size="sm" mdbBtn type="button" color="default"
        (click)="guardarYPasarAlSiguiente()" mdbWavesEffect class="btn btn-sm"
        [ngClass]="{btn: true, disabledContent: !enableGuardarYPasar}">
        Guardar y pasar al siguiente cliente
      </button>
      <button *ngIf="enableGuardarYPasar" size="sm" mdbBtn type="button" color="success"
        (click)="guardarYPasarAlSiguiente()" mdbWavesEffect class="btn btn-sm"
        [ngClass]="{btn: true, disabledContent: !enableGuardarYPasar}">
        Guardar y pasar al siguiente cliente
      </button>
      <!-- <button size="sm" mdbBtn type="button" color="success" (click)="openModalControlEfectivoComponent()"
        mdbWavesEffect class="btn btn-sm" [ngClass]="{btn: true, disabledContent: !enableCerrar}">
        Guardar
      </button> -->

      <app-api-button (click2)="openModalControlEfectivoComponent()" [processing]="processing || isProcessing"
        [ngClass]="{disabledContent: !enableCerrar}" [disabled]="isProcessing">Guardar</app-api-button>


    </div>
  </div>
</div>

<app-modal-control-efectivo (onControlEfectivoRealizado)="onControlEfectivoRealizado($event)"
  (onProcessingChance)="onProcesingChance(someBooleanValue)">
</app-modal-control-efectivo>

<app-modal-confirm title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
</app-modal-confirm>
